const bookListValues = [
  {
    id: 1,
    title: "Combined Print & E-Book Fiction",
    value: "combined-print-and-e-book-fiction",
  },
  {
    id: 2,
    title: "Combined Print & E-Book Nonfiction",
    value: "combined-print-and-e-book-nonfiction",
  },
  {
    id: 3,
    title: "Hardcover Fiction",
    value: "hardcover-fiction",
  },
  {
    id: 4,
    title: "Hardcover Nonfiction",
    value: "hardcover-nonfiction",
  },
  {
    id: 5,
    title: "Paperback Trade Fiction",
    value: "trade-fiction-paperback",
  },
  {
    id: 6,
    title: "Paperback Nonfiction",
    value: "paperback-nonfiction",
  },
  {
    id: 7,
    title: "Advice, How-To & Miscellaneous",
    value: "advice-how-to-and-miscellaneous",
  },
  {
    id: 8,
    title: "Children’s Middle Grade Hardcover",
    value: "childrens-middle-grade-hardcover",
  },
  {
    id: 10,
    title: "Children’s Picture Books",
    value: "picture-books",
  },
  {
    id: 11,
    title: "Children’s & Young Adult Series",
    value: "series-books",
  },
  {
    id: 12,
    title: "Young Adult Hardcover",
    value: "young-adult-hardcover",
  },
];

export default bookListValues;
